export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Science & Technology.00a4031e.png";